<ppl-auth-message
  icon="logout-restriction"
  label="You have been signed out"
  i18n-label="@@You_have_been_signed_out"
  [message]="message"
  actionLabel="Sign In"
  i18n-actionLabel="@@Sign_In"
  (action)="onSignIn()"></ppl-auth-message>
